/**
 * @generated SignedSource<<c4ccfe3ef8468b03fa74caacb43c77ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditableRound_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoundControls_Booking">;
  readonly " $fragmentType": "EditableRound_Booking";
};
export type EditableRound_Booking$key = {
  readonly " $data"?: EditableRound_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditableRound_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditableRound_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoundControls_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "4a93931fa58a187e1d0b467885385bda";

export default node;
